import axios from "axios";

export const getViewedProfiles = (query = null) => {
    return axios.get(`views${query ? ('?' + new URLSearchParams(query).toString()) : ''}`)
}